
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2022
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	// Application Title
	'appTitle': 'Gemini жобасы',
	'appExit': 'Басты бетке өту',


	'widgetsListLabel': 'Шеберлер тізімі. Шеберді таңдап және қосу үшін enter түймешігін басыңыз.',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	//General
	'listSeparator': ', ',
	'pointSeparator': ':',

	'insync': 'Соңғы нұсқасы',
	'dirty': 'Соңғы нұсқасы емес',
	'conflict': 'Көріністі сақтаушы қайшылық',
	'error': 'Көріністі сақтаушы ақау',
	'failure': 'Серверге байланысу мүмкін емес',
	'saveFailed': 'Көріністі сақтау мүмкін емес',

	'wa_insync': 'Сақталды',
	'wa_conflict': 'Көріністі сақтаушы қайшылық',
	'wa_error': 'Көріністі сақтау мүмкін емес',
	'wa_failure': 'Серверге байланысу мүмкін емес',

	// Menu Labels
	'changeDisplay': 'Дисплейді өзгерту',
	'changeToColumnChart': 'Баған диаграммасына өзгерту',
	'changeToBubbleChart': 'Көпіршікті диаграммаға өзгерту',
	'toggleMoveHandles': 'Ажырата қосу таңбалауыштарды жылжытады',
	'undo': 'Болдырмау',
	'redo': 'Қайтару',
	'mode': 'Режимді өзгерту',

	'untitled': 'Тақырыпсыз',
	'remove': 'Жою',
	'editTitle': 'Тақырыпты өңдеу',
	'edit': 'Өңдеу',
	'done': 'Аяқталды',

	// Data tray
	'dataTrayHandleOpenLabel': 'Ашық деректер берілімі',
	'dataTrayHandleCloseLabel': 'Жабық деректер берілімі',

	// Dialogs
	'dlg_loading': 'Жүктелуде...',
	'dlg_ok': 'OK',
	'dlg_create': 'Жасау',
	'dlg_cancel': 'Болдырмау',
	'dlg_close': 'Жабу',
	'dlg_update': 'Жаңарту',
	'dlg_renameBoardTitle': 'Бұл нысан атын қайта өзгерту',
	'dlg_renameDatasetTitle': 'Бұл деректер жиыны атын қайта өзгерту',
	'dlg_renameSceneTitle': 'Бұл сцена атауын қайта өзгерту',
	'dlg_NameLabel': 'Аты:',
	'dlg_NewNameLabel': 'Жаңа атауы:',
	'dlg_DefaultNameWithDataSet': '%{name} Көрініс',
	'dlg_ShareTitle': 'Мазмұнмен бөлісу',
	'dlg_UnshareTitle': 'Мазмұнмен бөлісуді алып тастау',
	'dlg_ShareUser': 'Пайдаланушы идентификаторы:',
	'dlg_NewColumnLabel': 'Жаңа есептеу аты',

	'dlg_new': 'Жаңа...',
	'dlg_open': 'Ашу...',
	'dlg_makeACopy': 'Көшірме жасау',
	'dlg_rename': 'Атын өзгерту...',
	'dlg_moreToCome': 'Қосымша әрекеттер күтілуде...',

	'dlg_use': 'Пайдалану',

	'dlg_RelinkDatasetTitle': 'Деректер жиыны \'%{datasetName}\' арқылы орны алмастырылады ...',

	'open_error': 'Көріністі ашу кезінде орын алған ақау.',

	// Delete Board
	'del_dialogTitle': 'Жоюды растау',
	'del_itemMsg': '\'%{name}\' жойғыңыз келетініне сенімдісіз бе?',
	'del_itemsMsg': '%{count} элементтерін жойғыңыз келетініне сенімдісіз бе?',
	'del_deleteErr': '\'%{name}\' жойылуы мүмкін емес',

	// List Sorting
	'dlg_ascending': 'Артуы бойынша',
	'dlg_descending': 'Кемуі бойынша',
	'dlg_custom': 'теңшелім',
	'dlg_none': 'Ешбір',

	// Input Placeholders
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'search': 'Іздеу',

	'searchHint': 'Барлық деректерді іздеу',
	'clearSearchResult': 'Іздеу нәтижелерін жою',
	// Shapes and shapes categories
	// Basic shapes
	'shapesBasicShapesCat': 'Негізгі',
	'shapesCircle': 'Шеңбер',
	'shapesHexagon': 'Алтыбұрыш',
	'shapesLine': 'Жол',
	'shapesOctagon': 'Сегізбұрыш',
	'shapesPentagon': 'Бесбұрыш',
	'shapesSquare': 'Шаршы',
	'shapesTriangle': 'Үшбұрыш',
	'shapesDiamond': 'Гауһар тас',
	'shapesTitle': 'Кескін сипаттары',


	// Advanced shapes
	'shapesAdvancedShapesCat': 'Кеңейтілген',
	'shapesSquareRounded': 'Шеңбердегі шаршы',
	'shapesStar': 'Жұлдыз',
	'shapesChevron': 'Бұрыштық тырнақша',
	'shapesBadge_ribbon': 'Таңба таспасы',
	'shapesBadge': 'Таңба',
	'shapesHeart': 'Жүрек',
	'shapesExclamation': 'Лептеу',
	'shapesTrendingup': 'Тренд өрлеуі',
	'shapesTrendingdown': 'Тренд төмендеуі',
	'shapesX': 'X',

	// People shapes
	'shapesPeopleCat': 'Адамдар',
	'shapesFemale': 'Әйел',
	'shapesHappyface': 'Қуаныщшты түр',
	'shapesMale': 'еркек',
	'shapesMan': 'Ер',
	'shapesNeutralface': 'Бейтарап түр',
	'shapesSadface': 'Мұңды түр',
	'shapesShakehands': 'Қол алысу',
	'shapesThumbsdown': 'Жарамайды',
	'shapesThumbsup': 'Жарайсың',
	'shapesWoman': 'Әйел',

	// Weather and places
	'shapesPlacesWeatherCat': 'Орындары & ауа райы',
	'shapesCity': 'Қала',
	'shapesCloud': 'Бұлт',
	'shapesEducation': 'Білім беру',
	'shapesGovernment': 'Үкімет',
	'shapesHalfcloud': 'Жарты бұлт',
	'shapesHouse': 'Үй',
	'shapesMoon': 'Ай',
	'shapesRain': 'Жаңбыр',
	'shapesSunny': 'Күнді',

	//Vehicles
	'shapesVehiclesCat': 'Автомобильдер',
	'shapesAirplane': 'Ұшақұ',
	'shapesCar': 'Жеңіл көлік',
	'shapesShip': 'Кеме',
	'shapesShoppingcart': 'Дүкен арбашасы',
	'shapesTrain': 'Поезд',
	'shapesTruck': 'Жүк көлігі',

	//Objects
	'shapesObjectsCat': 'Нысандар',
	'shapesBook': 'Кітап',
	'shapesBriefcase': 'Портфель',
	'shapesCalendar': 'Күнтізбе',
	'shapesCheck': 'Тексеру',
	'shapesClock': 'Сағат',
	'shapesDesktop': 'Жұмыс үстелі',
	'shapesDocument': 'Құжат',

	'shapesFood': 'Тамақ',
	'shapesGear': 'Механизм',
	'shapesHealth': 'Денсаулық',

	'shapesIdea': 'Идея',
	'shapesMobile': 'Ұялы',
	'shapesMoney_bill': 'Ақша шоты',
	'shapesMoney_coin': 'Ақша тиыны',
	'shapesPiggybank': 'Жинақтауыш',
	'shapesStackofpaper': 'Қағаз бумасы',
	'shapesStickynote1': 'Жазба 1',
	'shapesStickynote2': 'Жазба 2',
	'shapesTarget': 'Мақсаты',
	'shapesTool': 'Құрал',

	'shapesUmbrella': 'Қолшатыр',

	'shapesBrain': 'Ми',
	'shapesSkull': 'Бас сүйегі',
	'shapesEye': 'Көз',

	// Arrows shapes
	'shapesArrowsCat': 'Көрсеткілер',
	'shapesRightArrow': 'Оң жақ көрсеткі',
	'shapesLeftArrow': 'Сол жақ көрсеткі',
	'shapesDoubleArrow': 'Қосарлы көрсеткі',
	'shapesCurvedArrow': 'Қисық көрсеткі',

	// Callouts shapes
	'shapesCalloutsCat': 'Тілше деректер',
	'shapesRectCallout': 'Тілше дерек',

	// Images
	'imageWidgetTitle': 'Кескін виджеті',
	'imageTextLabel': 'URL мекенжайын қойыңыз және Енгізу батырмасын сақтау үшін басу',
	'imgUrl': 'Суреттің URL мекен-жайы',
	'imgPasteLink': 'URL мекенжайын қойыңыз және Енгізу батырмасын сақтау үшін басу',
	'imgResizeToFit': 'Кескін өлшеміне сәйкестендіру өлшемін қайта жасау',
	'imgHeight': 'Биіктігі:',
	'imgWidth': 'Ені:',
	'imgTransparency': 'Мөлдірлік:',
	'imgMissingUrl': 'Кескін URL мекенжайы мәліметі жоқ',
	'imgUrlValidationError': 'Кескін URL мекенжайы жарамды емес',
	'imgUrlInvalidDomainError': 'Кескіннің URL мекен-жайы әкімші мақұлдамаған доменге нұсқайды. Әкімші арқылы бекітілген домендер — "%{domains}"',


	// Data player widget
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'playButtonLabel': 'Ойнау',
	'dataPlayerValueListLabel': 'Деректер ойнатқышының мәндері',
	// Text Widget
	'textWidgetTitle': 'Мәтін виджеті',
	'textStyle': 'Мәнерлер',
	'textStyleDescription': 'Алдын ала пішімделген мәтін мәнерлері',
	'textTitleStyle': 'Тақырып',
	'textTitleSmallStyle': 'Кішкене тақырып',
	'textSubtitleStyle': 'Тақырыпша',
	'textBodyStyle': 'Негізгі мәтін',
	'textBodySmallStyle': 'Кіші мәтін',
	'textCaptionStyle': 'Тақырып',
	'textQuoteStyle': 'Дәйексөз',
	'textQuoteSmallStyle': 'Кіші дәйексөз',
	'textResponsiveStyle': 'Автоөлшем',
	'textAutoFontSize': 'Авто',
	'textFontFamilySubClassHairline': 'Жұқа сызық',
	'textFontFamilySubClassThin': 'Жіңішке',
	'textFontFamilySubClassThinItalic': 'Жіңішке көлбеу',
	'textFontFamilySubClassExtraLight': 'Қосымша жарық',
	'textFontFamilySubClassExtraLightItalic': 'Қосымша жарық көлбеу',
	'textFontFamilySubClassLight': 'Ашық',
	'textFontFamilySubClassLightItalic': 'Ашық көлбеу',
	'textFontFamilySubClassRegular': 'Қалыпты',
	'textFontFamilySubClassRegularItalic': 'Қалыпты көлбеу',
	'textFontFamilySubClassItalic': 'Көлбеу',
	'textFontFamilySubClassMedium': 'Орташа',
	'textFontFamilySubClassMediumItalic': 'Орташа көлбеу',
	'textFontFamilySubClassHeavy': 'Қалың',
	'textFontFamilySubClassHeavyItalic': 'Қалың көлбеу',
	'textFontFamilySubClassDemiBold': 'Жартылай қалың',
	'textFontFamilySubClassDemiBoldItalic': 'Жартылай қалың көлбеу',
	'textFontFamilySubClassBold': 'Қалың',
	'textFontFamilySubClassBoldItalic': 'Қалың көлбеу',
	'textFontFamilySubClassExtraBold': 'Қосымша қалың',
	'textFontFamilySubClassExtraBoldItalic': 'Қосымша қалың көлбеу',
	'textFontFamilySubClassBlack': 'Қара',
	'textFontFamilySubClassBlackItalic': 'Қара көлбеу',
	'textFontFamilySubClassStencil': 'Трафарет',
	'responsiveCoachmarkTitle': 'Автоөлшем қарпі',
	'responsiveCoachmarkContents': 'Бұл мәтін түрі өлшемін өзгерткен кезде қаріп өлшемі сәйкес болуы үшін автоматты түрде өлшемін өзгертеді. Мәтін сипаттары ішінде қаріп өлшемін орната аласыз.',

	'propText': 'Мәтін мәліметтері',
	'propTextReturn': 'Мәтін сипаттары',

	'textFontSize': 'Қаріп өлшемі',
	'textFontFamily': 'Қаріп жиынтығы',
	'textFontWeight': 'Қаріп салмағы',

	// Widget Properties
	'propImageLink': 'Кескін сілтемесі',
	'propMissingURL': 'URL мекен-жайын енгізу',
	'propImgTop': 'Сурет сипаттары',
	'propGeneralReturn': 'Басты сипаттар',
	'propStyle': 'Жалпы',
	'propStyleReturn': 'Жалпы',
	'propFillColor': 'Түспен толтыру',
	'propTextColor': 'Мәтін түсі',
	'propBorderColor': 'Жиек түсі',
	'propMaintainAxisScales': 'Білік өлшемін сақтап қалу',
	'propShowItemLabel': 'Элемент белгішесін көрсету',
	'propHideLegend': 'Мәнді белгілерді жасыру',
	'propColorPalette': 'Бояғыш',
	'propLegendPosition': 'Мәнді белгілер орналасуы',
	'propHideAxisTitleLabels': 'Білік тақырыптарын жасыру',
	'propLineColor': 'Сызық түсі',
	'propBubbleColor': 'Көпіршік түсі',
	'propInterpolation': 'Тегіс жолдар',
	'propElementColor': 'Көрнекі бейне элемент түсі',
	'propSymbolShape': 'Нышан кескіні',
	'propHeatScalePalette': 'Түрлі-түсті тапсырыс',
	'propHeatScalePalette_tooltipDarkerForLowerValue': 'Қоюлау түстер кішкене мәндерді ұсынады.',
	'propHeatScalePalette_tooltipDarkerForHigherValue': 'Қоюлау түстер жоғары мәнді де ұсынады.',
	'propImageDetails': 'Кескін мәліметтері',
	'propWebDetails': 'Веб парақша мәліметтері',
	'propMediaDetails': 'Мультимедиа мәліметері',
	'propPasteLink': 'URL мекенжайын енгізіңіз және Енгізу батырмасын басу',

	//Layout Properties
	'propPositionLabel': 'Орны',
	'propPositionXAxis': 'X',
	'propPositionYAxis': 'Y',
	'propResizeLabel': 'Өлшем',
	'propResizeWidth': 'Ені',
	'propResizeHeight': 'Биіктік',
	'propRotateLabel': 'Айналдыру',
	'propRotateAngle': 'Бұрыш',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'propScaleLabel': 'Белгішелер саны',
	'propScaleDescription': 'Белгішелер санын таңдау',
	'propScaleFew': 'Төмен',
	'propScaleDefault': 'Әдепкі',
	'propScaleMany': 'Жоғары',

	'mediaAriaLabel': 'url кірісі',
	'ariaGroupLabel': 'Төменге жылжу тізімінің санаты: %{cateoryLabel} элементі: %{itemLabel}. Шығару үшін DOWN пернесін басыңыз. Шарлау үшін UP және DOWN пернесін басыңыз немесе тасалау үшін ESCAPE пернесін басыңыз.',

	// Timer
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'lastRefresh': 'Соңғы жаңарту: %{timeInterval} бұрын',
	'widgetTimer': 'Виджет таймері',

	// Theme colors
	'transparent': 'Түсі жоқ',
	'white': 'Ақ',
	'lightGrey': 'Ашық сұр',
	'grey': 'Сұр',
	'darkGrey': 'Күңгірт сұр',
	'black': 'Қара',
	'lightBlue': 'Ашық көк',
	'blue': 'Көк',
	'darkBlue': 'Күңгірт көк',
	'yellow': 'Сары',
	'orange': 'Қызғылт сары',
	'lime': 'Ашық жасыл',
	'green': 'Жасыл',
	'peach': 'Шабдалы',
	'red': 'Қызыл',
	'violet': 'Қызыл көк',
	'aqua': 'Көгілдір',
	'purple': 'Күлгін',
	'plum': 'алхоры',

	//Theme Palette Label
	'paletteLabel': 'IBM бояғышы %{number}',
	'heatPaletteLabel': 'IBM жылу бояғышты %{number}',
	'conditionalPaletteLabel': 'IBM шартты бояғышты %{number}',
	'userPaletteColor_lightTheme': 'IBM жеңіл бояғышты',
	'userPaletteColor_defaultTheme': 'IBM әдепкі бояғышы',
	'userPaletteColor_darkTheme': 'IBM қараңғы бояғышы',

	// Dashboard
	'propDashboardBackgroundColor': 'Өң түсі',
	'dataCache': 'Деректер кэші',
	'dataCache_on': 'Сеансты қосу',
	'dataCache_off': 'Кэш жоқ',
	'dataCache_auto': 'Автоматты',
	'propLayoutPositioning': 'Схеманы орналастыру',
	'propLayoutRelative': 'қатыстық',
	'propLayoutAbsolute': 'Нақпа-нақ',
	'propLayoutPositioningCoachmarkTitle': 'Схема мәнерін таңдаңыз',
	'propLayoutPositioningCoachmarkContent': 'Салыстырмалы схемада виджеттердің өлшемі мен орналасуы экранға ену үшін реттеледі. Абсолюттік схемада виджеттер экран өлшеміне қарамастан, сіз өлшемі бойынша дәл көрінеді және оларды көріністе орналастырады.',
	'gridText': 'Торды көрсету',
	'snapText': 'Торға бекіту',
	'snapObjectsText': 'Нысандарга бекіту',
	'fitPageText': 'Бетті сыйдыру',
	'gridLabel': 'Жоғарғы',
	'heightUnit': 'с',
	'widthUnit': 'w',
	'pixelUnit': 'px',
	'propPageSizeLabel': 'Бет өлшемі',
	'propPageSizePresetAriaLabel': 'Алдын-ала орнатылған бет өлшемі',
	'propPageSizePreset': 'Дайындама',
	'propPageSizePresetCustom': 'Теңшелім',
	'propPageSizePreset16x9': 'Экран 16:9',
	'propPageSizePreset4x3': 'Экран 4:3',
	'propPageSizePresetInfographic': 'Инфографика',
	'propPageSizeWidth': 'Ені',
	'propPageSizeHeight': 'Биіктік',
	'propPageSizeWidthAriaLabel': 'Бет өлшемінің ені',
	'propPageSizeHeightAriaLabel': 'Бет өлшемінің биіктігі',
	'propPageSizeAdjustedMessage': 'Бет өлшемі ұлғайтылды, себебі сіздің жазбаңыз ең төменгі деңгейден төмен немесе сіздің бақылау тақтаңызға сәйкес келмеді.',
	'propTabShow': 'Қойындыларды көрсету',
	'propShowTabsInPreview': 'Алдын ала қарау бөлімінде қойындыларды көрсету',
	'multilingualDashboardsLabel': 'Тілдер',
	'multilingualDashboardsDefault': '%{defaultLanguage} -- Әдепкі',
	'multilingualDashboardsAddLinkText': 'Басқа тіл қосу',
	'multilingualDashboardsSelect': 'Таңдау',
	'multilingualDashboardsButtonLabel': 'Қосу',
	'multilingualDashboardTranslationMode': 'Қазір аударма режиміндесіз (%{currentLanguage})',
	'multilingualDashboardTranslationDone': 'Аяқталды',
	'multilingualDashboardRemainingStrings': '%{numTranslationsLeft} қалған аудармалар',
	'multilingualDashboardRemainingString': '1 аударма қалды',
	'multilingualDashboardsSetDefault': 'Әдепкі тілді орнату',
	'multilingualDashboardIconMore': '%{currentLanguage} тіліне арналған қосымша әрекеттер',
	'multilingualDashboardIconTranslatableArea': 'Аударылатын аумақ',
	'multilingualDeleteTitle': 'Тілді жою',
	'multilingualDeleteLanguageWarning': '\'%{language}\' тілін жоюға сенімдісіз бе?',
	'multilingualSelectLanguage': 'Тілді таңдаңыз',
	'confirmLayoutStyleUpgradeTitle': 'Барлық қойындыларға қолданыңыз',
	'confirmLayoutStyleUpgrade': 'Бұл схема мәнерін бақылау тақтасындағы барлық қойындыларға қолдану керек пе?',

	//Tabs
	'tabDeleteDialogYesButton': 'Иә',
	'tabDeleteDialogNoButton': 'Жоқ',
	'tabDeleteDialogTitle': 'Осы қойындыны жою керек пе?',
	'tabDeleteDialogMessage': 'Осы қойындыдағы барлық мазмұн жойылады.',

	// Vis widget
	'propVisTypeReturn': 'Көрнекі бейне түрлері',
	'propVisDetails': 'Мәліметтер',

	// Alignment picker
	'propAlignPickTop': 'Жоғары шетпен туралау',
	'propAlignPickRight': 'Оң жақ бойынша туралау',
	'propAlignPickBottom': 'Төменгі шетпен туралау',
	'propAlignPickLeft': 'Сол жақ бойынша туралау',
	'propAlignPickCenter': 'Ортасы бойынша туралау',
	'propAlignPicker': 'Туралау',

	// Toolbar picker
	'propToolbarPickBold': 'Қалың',
	'propToolbarPickUnderline': 'Астын сызу',
	'propToolbarPickItalic': 'Көлбеу',
	'propToolbarPickJustifyLeft': 'Сол жақ бойынша туралау',
	'propToolbarPickJustifyCenter': 'Ортасы бойынша туралау',
	'propToolbarPickJustifyRight': 'Оң жақ бойынша туралау',
	'propToolbarPickJustify': 'Туралау',

	'propList': 'Тізім',
	'propOrderedList': 'Реттестірілген тізім',
	'propUnorderedList': 'Реттестірілмеген тізім',

	// Symbol shapes
	'propCircle': 'Шеңбер',
	'propTriangle': 'Үшбұрыш',
	'propSquare': 'Шаршы',
	'propRect': 'Тіктөртбұрыш',
	'propStar': 'Жұлдыз',
	'propCross': 'Қиылысу',
	'propPlus': 'Қосу',
	'propPoly': 'Көпбұрыш',


	// True and false selection
	'propTrue': 'True',
	'propFalse': 'False',

	// Position selection
	'propLeft': 'Сол',
	'propRight': 'Оң',
	'propTop': 'Үстіңгі',
	'propBottom': 'Төменгі',

	// Interpolation options
	'propSmooth': 'Тегіс',
	'propStraight': 'Тура',

	// indentedListView
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'srILVTreeLabel': 'Тізім', // screen reader label for tree role

	// widget move
	'srWidgetMoveLeft': 'Сол жаққа жылжу', // screen reader
	'srWidgetMoveUp': 'Жоғары жылжыту', // screen reader
	'srWidgetMoveRight': 'Оң жаққа жылжу', // screen reader
	'srWidgetMoveDown': 'Төмен жылжыту', // screen reader

	// widget resize
	'srWidgetResizeBigger': 'Өлшемді пропорционалды аралықта үлкейту', // screen reader
	'srWidgetResizeSmaller': 'Өлшемді пропорционалды аралықта азайту', // screen reader
	'srWidgetResizeBiggerV': 'Вертикалды бағытта үлкейту', // screen reader
	'srWidgetResizeSmallerV': 'Вертикалды бағытта азайту', // screen reader
	'srWidgetResizeBiggerH': 'Көлденең бағытта үлкейту', // screen reader
	'srWidgetResizeSmallerH': 'Көлденең бағытта азайту', // screen reader

	// widget rotate
	'srWidgetRotateCW': 'Сағат тілі бағытында айналдыру', // screen reader
	'srWidgetRotateCCW': 'Сағат тілі бағытына қарсы айналдыру', // screen reader

	// Recommended types
	'visChange': 'Көрнекі бейнелерді өзгертіңіз',

	// Visualization
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'visualizationLabel': 'Көрнекі бейне',
	'chartLabel': '%{chartName} диаграммасы',
	'dataWidgetDescription': '%{widgetLabel}: %{columnNames}',
	'f12KeyDescription': 'Виджет арқылы шарлау үшін F12 түймешігін басыңыз',
	'f10KeyDescription': 'Виджеттің меңзеу көрінісін орналастыру үшін F10 түймешігін басыңыз',

	'WidgetLabelWithDescripion': '%{label}. %{description}',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'summaryLabel': '%{label} мәнімен %{value}',

	'shapeColorLabel': 'Кескін түсі',
	'showLegendLabel': 'Мәтінмәндік белгіні көрсету',

	//Webpage
	'webpageWidgetTitle': 'Веб бетінің виджеті',
	'webpagePasteLink': 'URL мекенжайын қойыңыз және Енгізу батырмасын сақтау үшін басу',
	'propWebpageLink': 'Веб парақша URL мекенжайы',
	'propWebpageTitle': 'Веб парақша тақырыбы',
	'propWebpageTitleDescription': 'Веб парақшаның тақырыбы',
	'propWebpageTop': 'Веб парақша сипаттары',
	'webpageMissingUrl': 'Веб парақша URL мекенжайы мәліметі жоқ',
	'webpageUrlValidationError': 'Веб парақша URL мекенжайы жарамды емес',
	'webpageHttpValidationError': 'Веб парақша шолушы HTTPS сілтемесі көмегімен қатынас орнатылып көрсетеді',
	'webpageInvalidDomainError': 'Веб-бет URL мекен-жайы әкімші мақұлдамаған доменді көрсетеді. Әкімші арқылы бекітілген домендер — "%{domains}"',

	//VizState
	'vzErrorLoading': 'Көрнекі бейнені жүктеу мүмкін болмады',
	'vzErrorLoadingMissingData': 'Көрнекі бейнен жүктеу мүмкін болмады, мәтінмән дерегі жеткіліксіз',

	//Media (Video / Audio)
	'mediaWidgetTitle': 'Мультимедиа виджет',
	'mediaPasteLink': 'URL мекенжайын қойыңыз және Енгізу батырмасын сақтау үшін басу',
	'videoHeight': 'Биіктігі:',
	'videoWidth': 'Ені:',
	'propMediaLink': 'Мультимедия сілтемесі',
	'propMediaTitle': 'Мультимедиа тақырыбы',
	'propMediaTitleDescription': 'Мультимедияның тақырыбы',
	'propMediaTop': 'Мультимедия сипаттары',
	'mediaMissingUrl': 'Мультимедия сілтемесі URL мекенжайы мәліметі жоқ',
	'mediaUrlValidationError': 'Мультимедия файлы URL мекенжайы жарамды емес',
	'mediaUnknownValidationError': 'Мультимедия бұл түріне қолдау көрсетілмейді',
	'mediaHttpValidationError': 'Мультимедия файлы шолушы HTTPS сілтемесі көмегімен қатынас орнатылып көрсетеді',
	'mediaInvalidDomainError': 'Медиа файл URL мекен-жайы әкімші мақұлдамаған доменді көрсетеді. Әкімші арқылы бекітілген домендер — "%{domains}"',

	// Properties pane
	'commonPropertiesLabel': 'Сипаттар',

	// Data strip
	'dataSetsLabel': 'Деректер орнатуы',
	'dataViewsLabel': 'Көрініс',
	'columnQuality': 'Деректер сапасы',
	'columnProperties': 'Дерек сипаттары',

	'dataQuality': 'Деректер сапасы',
	'dataQualityRowCount': 'Жолдар саны',
	'dataQualityDistribution': 'Тарату',
	'dataRowLabel': 'Деректер',

	// Modelling UI
	'typeColumn': 'Түрі',
	'modellingColumnType': 'Түрі',
	'modellingColumnAggregation': 'Біріктіру',
	'modellingColumnUsage': 'Пайдалану',
	'modellingColumnSort': 'Сұрыптау',
	'modellingColumnFormat': 'Пішім',
	'modellingColumnCategory': 'Санат',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'modellingLoading': 'Жүктелуде...',

	'modellingProcessing': 'Өңделуде...',
	'modellingImport': 'Импорттау',
	'modellingReimport': 'Қайта импорттау',
	'modellingDatasourceTitle': 'Деректер көзі',
	'modellingImportStartedTitle': 'Испорттау іске ұосылуы',
	'modellingImportStartedText': 'Жеке деректерді импорттау біршама уақыт алуы мүмкін.\n\n(Деректер импорттау уақытында қажетті көріністі жасай аласыз.)',
	'importDatasourceTitle': 'Қосылымдар',
	'dropHere': 'Жаңа дерек көзін жасау үшін осы жерге апарыңыз...',
	'browseButton': 'Шолу',
	'errorNoData': 'Өңдеуге қажет деректер бұл жерде жоқ.',
	'errorNoFile': 'Жүктеп салуға қажетті файл жоқ.',
	'errorUploadFailed': 'Жүктеп салу мүмкін емес.',
	'uploadSucceessful': 'Жүктеп салу сәтті орындалуы',
	'del_datasourceTitle': 'Деректер жиынын жою',
	'del_datasourceMsg': '\'%{name}\' жойғыңыз келетініне сенімдісіз бе?',
	'modellingFileUpdate': 'Жаңарту',
	'modellingFileUpdateTitle': 'Деректер жиынын жаңарту',
	'modellingFileUpdateDescription': '\'%{name}\' жаңартуды қалайсыз ба?',
	'modellingFileUpdatingTitle': '\'%{name}\' жаңартуы',
	'modellingUpdateStartedTitle': 'Жаңартуды импорттау басталды',
	'modellingUpdateStartedText': 'Жеке деректерді жаңарту біршама уақыт алуы мүмкін.\n\n(Деректер жаңарту уақытында қажетті көріністі жасай аласыз.)',
	'modellingErrorImportUploadNoFile': 'Жүктеп салатын файл жоқ.',
	'modellingErrorImportUploadFailed': 'Жүктеп салу мүмкін емес.',
	'modellingErrorImportUploadInvalidType': 'Файл түрі жарамды емес.',
	'modellingErrorImportUploadTableFailed': 'Кестелерді алу мүмкін емес.',
	'modellingIntentResultsTitle': 'ұсынылған деректер жиынын қолдану үшін таңдаңыз',
	'modellingColumnViewRelationships': 'Байланысты кестелерді көріңіз',
	'modellingTableRelatedTables': '\'%{name}\' байланысты кестелер',
	'modellingTable': '%{name} - Кесте',
	'modellingColumnIncludedInDataSet': 'Қосылған',
	'modellingDataSet': 'Деректер орнатуы',
	'modellingViewInDataSet': 'Деректер жиынында көріңіз',
	'modellingViewRelatedTables': 'Байланыстыларды көру',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'modellingRelatedTablesNoneFound': 'Байланысты кестелер табылмады',

	'modellingValidatingDataset': 'Тексеруде...',
	'datasetFinishedRefreshing': 'Деректер жиыны %{datasetName} жаңартылуда.',



	// Join UI - Navigation Controller titles
	'modellingJoinTable': 'Біріктіру жолын шешу:',
	'modellingJoinColumns': 'Келесі кесте үшін біріктіру жолын анықтаңыз: %{name}',
	'modellingJoinToTable': 'Келесі кестеге біріктіріңіз: %{name}',

	// Data Quality
	'excluded': 'Алып тасталған',
	'metricPrefixThousand': 'K',
	'metricPrefixMillion': 'М',
	'metricPrefixBillion': 'B',
	'metricPrefixTrillion': 'T',
	'metricPrefixQuadrillion': 'Q',

	//Column Flyout
	'modellingColumnFilter': 'Сүзгі',
	'modellingColumnSortNone': 'Сұрыптауды тазалаңыз',
	'modellingColumnSortAsc': 'Артуы бойынша сұрыптау',
	'modellingColumnSortDesc': 'Кемуі бойынша сұрыптау',
	'modellingColumnRemove': 'Бұл бағанды алып тастау',

	// Import File Browser
	'dropboxPageTitle': 'Жаңа Dropbox қосылымы',
	'sizeColumn': 'Өлшем',

	//Modelling Column Property Values
	'dataType_string': 'Тармақ',
	'dataType_date': 'Күні',
	'dataType_integer': 'Бүтін сан',
	'dataType_double': 'Қос',
	'dataType_float': 'Қалқу',
	'dataType_boolean': 'Логикалық өрнек',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'defaultAggregation_count': 'Есеп',
	'defaultAggregation_countdistinct': 'Ерекше мәндерді есептеу',
	'defaultAggregation_max': 'Ең үлкен',
	'defaultAggregation_min': 'Ең кіші',
	'defaultAggregation_avg': 'Орташа',
	'defaultAggregation_sum': 'Қосынды',
	'defaultAggregation_auto': 'Авто (%{aggregationType})',

	'type_fact': 'Факт',
	'type_attribute': 'Төлсипат',

	'defaultSort_none': 'Сұрыптамау',
	'defaultSort_asc': 'Артуы бойынша сұрыптау',
	'defaultSort_desc': 'Кемуі бойынша сұрыптау',

	'category_none': 'Ешбір',
	'category_location': 'Орны',
	'category_monetary': 'Валюталық',
	'category_time': 'Уақыт',

	// Root menu
	'rootMenuTitle': 'Негізгі мәзір',

	'errorMessageTitle': 'Қате',
	'errorMessageDetails': 'Мәліметтер: ',
	'errorMessageTitleAssetAlreadyExists': 'Бұл актив алдында жасалған',

	'defaultTabTitle': 'Қойынды %{index}',
	'tabAddBtnTitle': 'Жаңа қойындыны қосу',

	'unsupportedConditionalFormattingEncountered': 'Шартты пішімдеу енді кейбір бағандарға қолданылмайды.',


	// Homepage View
	'nameColumn': 'Аты',
	'creatorColumn': 'Жасаған',
	'creationDateColumn': 'Жасалған күн',
	'versionColumn': 'Нұсқа',
	'modifiedColumn': 'Соңғы өзгертілген',

	'filterBy': 'Cүзгілеу элементтері',
	'allFilter': 'Барлық элементтер',
	'createdByMeFilter': 'Менімен жасалған',
	'sharedWithMeFilter': 'Менімен ортақ',
	'favoritesFilter': 'Менің таңдаулыларым',
	'recentsFilter': 'Жақын арада қосылған',
	'sortBy': 'Сұрыптау әдісі',

	// Sort Menu
	'sortModified': 'Өзгертілген',
	'sortUpdated': 'Жаңартылған',
	'sortName': 'Аты',

	'viewAs': 'Көрініс ету',
	'thumbnailsView': 'Нобайлар ретінде көру',
	'listView': 'Тізім ретінде көру',
	'createMenu': 'Жасау',
	'newAppItem': 'Бақылау тақтасы',
	'newDataSet': 'Деректер орнатуы',

	'menuSelectionState_a11y': '"%{item}" таңдаушысы "%{selectedItem}" орнатылған',

	'unableToShareItem': '"%{item}" элементімен бөлісу мүмкін емес.',
	'toastFetchingContent': 'Қосымша мазмұн алу үстінде...',
	'unableToGetData': 'Мазмұн қабылдау мүмкін емес.',
	'unableToFavorite': 'Таңдаулы күйін өзгерту мүмкін емес.',
	'hpErrorMissingRequiredOptions': 'Қажетті баптандыру опциялары жетіспейді',
	'unableToOpenBoard': '"%{name}" ашу мүмкін емес.',
	'unableToDuplicateBoard': '"%{name}" көшірмелеу мүмкін емес.',
	'unableToCreateBoard': '"%{name}" жасау мүмкін емес.',
	'unableToCreateBoardNameConflict': 'Нақ осындай атаулы актив бар.',

	// DataSet Detail View
	'status': 'Күй',
	'numberOfRows': 'Жолдар',
	'importWarnings': 'Ескертулер',
	'lineNumbers': 'Жолдар',
	'excerptFromSource': 'Excerpt',
	'reason': 'Себебі',
	'numberOfRowsDropped': 'жолдар мәтінде',
	'oneRowDropped': '1 жол мәтінде болған',

	// Type Menu
	'typeMenuLabel': 'Түрі',
	'dashboardsLabel': 'Бақылау тақталары',
	'datasetsLabel': 'Дерек жиындары',
	'storiesLabel': 'Мақалалар',
	'allLabel': 'Барлық түрлері',

	// Board Page View App Bar
	'datasets': 'Дерек жиындары',
	'settings': 'Сипаттар',
	'add': 'Қосу',
	'widgets': 'Виджеттер',
	'dashboardProperties': 'Бақылау тақтасы сипаттары',
	'pins': 'Жиын',
	'pinsOld': 'Менің бекітулерім',
	// For languages with more than one plural form, provide the different forms delimited by |||| in the string below.
	// See https://github.com/airbnb/polyglot.js#pluralization
	'pinCount': '%{smart_count} pin |||| %{smart_count} pins',
	'pinSearch': 'Іздеу',
	'pinSearchOld': 'Бекітулерді іздеу',
	'pinListView': 'Тізім көрінісі',
	'pinIconView': 'Белгіше көрінісі',
	'pinRemove': 'Жою',
	'pinCreate': 'Жасау',
	'pinDeleteError': 'Жиыннан бір немесе бірнеше активтерді жоя алмаймыз. Әрекетті кейінірек қайталаңыз.',
	'pinDeleteErrorOld': 'Бір немесе бірнеше бекітулерді жоя алмаймыз. Әрекетті кейінірек қайталаңыз.',
	'pinRetrieveError': 'Бір немесе бірнеше бекітулерді шығара алмаймыз. Әрекетті кейінірек қайталаңыз.',
	'NoPinsCollected': 'Бекітілген көрсетілімдер жоқ',
	'pinDeletedToast': 'Бекіту жойылды',
	'pinAddedToast': 'Бекіту Менің бектілеріме сәтті қосылды',
	'pinningToast': 'Бекіту өңдеу...',
	'pinDateFilter': 'Күндер сүзгісі',
	'pinDateFilterAll': 'Барлық',
	'pinDateFilterToday': 'Бүгін',
	'pinDateFilterYesterday': 'Кеше',
	'pinDateFilterPastWeek': 'Өткен апта',
	'pinDateFilterPastMonth': 'Өткен ай',
	'pinDateFilterEarlier': 'Алдыңғы',

	// data widget contextual toolbar labels
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'toolbarActionEditTitle': 'Тақырыпты өңдеу',
	'toolbarActionSort': 'Сұрыптау',
	'toolbarActionSortAscending': 'Артуы бойынша сұрыптау',
	'toolbarActionSortDescending': 'Кемуі бойынша сұрыптау',
	'toolbarActionSortAuto': 'Авто (%{sortOrder})',
	'toolbarActionFormat': 'Пішім',
	'toolbarActionFormatAbbreviation': 'Аббревиатура',
	'toolbarActionFormatNone': 'Авто',
	'toolbarActionFilter': 'Сүзгі',
	'toolbarActionTopBottom': 'Жоғары немесе төмен',
	'toolbarActionAddShape': 'Кескінді қосу',
	'toolbarActionRmvShape': 'Кескінді жою',
	'toolbarActionToggleShapeDrop': 'Инфографика пішіні',
	'toolbarActionToggleShapeDropTitle': 'Инфографика жасау',
	'toolbarActionToggleShapeDropText': 'Инфографика жасау үшін осы өріске арналған пішінді сүйреңіз.',
	'toolbarActionAggregationType': 'Жинақтау',
	'toolbarDeleteActionText': 'Бағанды жою',
	'toolbarActionFilterLocalKeepSelected': 'Сақтау',
	'toolbarActionFilterLocalExcludeSelected': 'Шығарып тастау',
	'toolbarActionFilterAllKeepSelected': 'Сүзгі',
	'toolbarActionSimpleCalculation': 'Қарапайым есептеулер',
	'toolbarActionDrillBack': 'Артқа',
	'toolbarActionDrillUp': 'Жоғары жылжу',
	'toolbarActionDrillDown': 'Төмен жылжу',
	'toolbarActionNavigate': 'Шарлау',
	'toolbarActionCreateFilterGroup': 'Жаңа байланыс жасау',
	'toolbarActionDisconnectFilterGroup': 'Барлық сілтемелерді бұзу',
	'toolbarActionLinkFilterGroup': 'Бар байланысқа қосу',

	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',

	// Side bar
	'sidebarAdd': 'Қосу',
	'sidebarMultiselect': 'Бірнеше таңдауды ажырата қосу',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'multiselectMsg': '%{count} таңдаулы',

	'multiselectWithTotalMsg': '%{count} %{total} ішінде',
	'sidebarGoBack': 'Қайту',

	//DataSet pane
	'errorLoadingDataSets': 'Бұл деректер жиынын жүктей алмадық',
	'errorLoadingDataSetMetaData': 'Бұл деректер жиынын жүктей алмадық',
	'dataSetPaneLastUpdated': 'Соңғы жаңартылған: %{date}',
	'dataSetPaneDateUnknown': 'Белгісіз',
	'sourcePaneLabel': 'Таңдалған көздер',
	'addSourceLabel': 'Қор көзін қосу',
	'find_label': 'Табу',
	'navigationPathsLabel': 'Шарлау жолдары',

	//widgetlist
	'errorLoadingWidgetList': 'Бұл нысандарды жүктей алмаймыз.',
	'errorLoadingThemeFile': 'Бұл тақырып анықтамасын жүктей алмаймыз',
	'errorLoadingLayoutFile': 'Бұл көріністі жүктей алмаймыз.',

	//data widget

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'dwErrorLoadingAvailableVisualizations': 'Қолжетімді көрнекі бейне анықтамаларын жүктей алмаймыз',

	'dwErrorLoadingVisualizationNotFound': 'Нысанды жүктей алмадық, себебі көрнекі бейне анықтамасы жеткіліксіз',
	'dwErrorLoadingVisualizationListNotFound': 'Көрнекі бейнені жүктей алмадық.',
	'dwErrorRunningQuery': 'Деректер жиынынан %{datasetName} деректерін шығарып ала аласыз.',
	'dwErrorGeoData': 'Картада географиялық деректерді көрсетудегі қиындықтармен кездестік. Өзге көрнекі бейне түрін таңдауыңызды өтінеміз. ',
	'dwPromptSignonCancelWarning': 'Бұл көрсетілімге арналған дерек қол жетімсіз. Дұрыс тіркелгілерді қамтамасыз етіңіз.',
	'dwErrorMissingDataset': 'Көрнекілеуді жүктей алмаймыз, себебі оның байланысты деректер жиыны \'%{datasetName}\' қолжетімді емес.',
	'dwErrorRenderingVisualization': 'Бұл көрнекі бейнені жүктей алмадық.',
	'dwErrorVisualizationTooSmall': 'Қамтитын деректерді көрсету үшін көрнекі бейне тым кішкентай. Көрнекі бейнені үлкейтіңіз не құрамындағы деректерге шектеу орнатыңыз.',
	'aria_label_datatable': 'Дерек кестесі',
	'aria_key_navi_datatable_desc': 'Әр бір ұяшық үшін шарлауда көрсеткі пернелерін қолданыңыз. Бірінші жолға көшу үшін Control және Home пернесін басыңыз, соңғы жолға көшу үшін Control және End пернесін басыңыз.',
	'geomapUnrecognizedLocations': 'Таныс емес орналасу орындары:',
	'geomapAmbiguousLocations': 'Мағыналы аймақтар:',

	// custom widget
	'customWidget': 'Тұтыну виджеті',
	'noCustomWidgets': 'Тұтыну виджеттері жоқ',

	// Action names
	'toggleContextBar': 'Мәтінмән тақтасын ажырата қосу',
	'delete': 'Жою',
	'share': 'Ортақ пайдалану',
	'unshare': 'Бөліспеу',
	'rename': 'Атын өзгерту',
	'close': 'Жабу',
	'duplicate': 'Көшірмелеу',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'retry': 'Әрекетті қайталау',

	'changeTemplate': 'Үлгіні өзгерту',

	// Aggregation Types
	'sum': 'Қосынды',
	'count': 'Есеп',
	'countdistinct': 'Ерекше мәндерді есептеу',
	'avg': 'Орташа',
	'min': 'Ең кіші',
	'max': 'Ең үлкен',
	'custom': 'Теңшелім',
	'calculated': 'Есептелген',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8

	'aggregatedColumnLabel': '%{column} (%{aggregationTypeLabel})', // For example, the sum of Revenue

	//simple calculation
	'percDifferenceOp': '% change',
	//For example, Profit - Expenses
	'calculationTitle': '%{col1} %{operator} %{col2}',

	'templateWidgetPlaceholderInput': 'Көрнекі бейненің шарты...',
	'QuickAddResultsHeader': 'Деректер көрнекі бейнелері',
	'NoQuickAddResults': 'Ниетіңізге еш нәрсе сай келмейді. Жаңа деректер жиынын жасайсыз ба?',
	'NoQuickAddResultsRetry': 'Ешбір сәйкестіктер таба алмадық. Өзге терминдер көмегімен тырысып көріңіз.',
	'templateWidgetTitle': 'Үлгі',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'nullValueLabel': '(бос)',

	'nullValueContent': '(мәні жоқ)',
	'nullValueText': 'Бос мән',

	// Modelling / Data Shaping
	'textFilterControlRegionLabel': 'Мәтін сүзгісі - %{columnName}',

	'textFilterSelectTab': 'Таңдау',

	'textFilterConditionTab': 'Шарт орнату',
	'textFilterItemsSelected': '(%{selected})',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'textFilterItemsNotFound': 'Ешбір элемент қолжетімді емес.',

	'textFilterEquals': 'Теңдік белгісі',
	'textFilterContains': 'Құрамында бар',
	'textFilterBeginsWith': 'келесімен басталады',
	'textFilterEndsWith': 'келесімен аяқталады',
	'textFilterDoesNotEqual': 'Тең емес',
	'textFilterDoesNotContain': 'Құрамында жоқ',
	'textFilterDoesNotBeginWith': 'Келесімен басталмайды',
	'textFilterDoesNotEndWith': 'Келесімен аяқталмайды',
	'textFilterSampleText': 'Мысалы: A',

	'textFilterAndButton': 'Және',
	'textFilterOrButton': 'Немесе',

	'dateFilterMessage': 'Деректер ауқымын таңдаңыз',
	'dateRangeControlRegionLabel': 'Дерек ауқымының сүзгісі - %{columnName}',
	'dateFilterRangeOption': 'Ауқым параметрі',
	'dateFilterDateLabel': 'Күні',
	'dateFilterBlank': '(бос)',
	'dateFilterBefore': 'Дейін',
	'dateFilterAfter': 'Кейін',
	'dateFilterBetween': 'Арасында',
	'dateFilterSampleText': 'DD.MM.YYYY',
	'dateTitle': 'Күні',
	'dateIncludeBlankLabel': 'Бос күнді қамтиді',

	'timeTitle': 'Уақыт',
	'timeFilterMessage': 'Уақыттар ауқымын таңдаңыз',
	'dateTimeFilterMessage': 'Күндер және уақыттар ауқымын таңдаңыз',

	'topbottomNumberOfResultsLabel': 'Нәтижелер саны',
	'topbottomPercentLabel': 'Пайыз',
	'topbottomNumberOfResultsLimit': '%{lower}-%{higher} аралығы',
	'topbottomSelectOption': 'Жоғарғы немесе төменгі опция',
	'topbottomOptionLabel': 'Көрсету',
	'searchByLabel': 'Арқылы',
	'searchNoMatches': 'Сәйкестіктер табылған жоқ',
	'topbottomRankColumnLabel': 'Кестеге дәреже бағанын қосыңыз',
	'topbottomNone': 'Ешбір',
	'topCount': 'Жоғарғы санақ',
	'topPercent': 'Жоғарғы %',
	'bottomCount': 'Төменгі санақ',
	'bottomPercent': 'Төменгі %',
	'topbottomSearchColumn': 'Бағанды табу',
	'searchColumnAriaLabel': 'Бағанды табу. Тізім ішінде бағанды табу үшін содан кейін төменгі көрсеткі пайдалану үшін іздеу баған атауын теріп енгізіңіз',
	'rankColumnLabel': 'Дәреже (%{columnLabel})',
	'topbottomClearLabel': 'Тазалау',

	'rangeFilterControlRegionLabel': 'Ауқым сүзгісі - %{columnName}',

	// Slider
	'sliderRegionLabel': 'Жүгірткі басқаруы, жүгірткі таңбалауыштарын жылжыту үшін оң және сол жақ көрсеткілерін қолданыңыз',
	'sliderHandleLabel': 'Жүгірткі таңбалауышы',
	'a11ySliderHandleLabel': 'Жүгірткі таңбалауышы %{sliderValue}',
	'sliderInputLabel': 'мән',

	// Refinery - Hidden columns
	'datasetItemsUnavailable': 'Бұл көрнекі бейнеде қолданылған кейбір деректер жиыны элементтері қолжетімсіз.',
	'datasetItemUnavailable': 'Бұл деректер жиыны элементі қолжетімсіз',

	//Authoring topBottom
	'topOperator': 'Үстіңгі',
	'bottomOperator': 'Төменгі',
	//For dimension column. eg: Top 5 by Quantity. %{operator} is topOperator or bottomOperator, %{val} is a number and %{fact} is a column name.
	'topBottomFact': '%{operator} %{value} by %{columnLabel}',
	//For fact column. eg: Top 10. %{operator} is topOperator or bottomOperator and %{val} is a number.
	'topBottomDimension': '%{operator} %{value}',
	'topBottomTitle': 'Тек осы нысан',
	'deleteTopBottom': 'Жоғарғы не төменгі санақты жойыңыз',
	'editTopBottom': 'Жоғарғы не төменгі санақты өңдеңіз',
	'deleteDrillState': 'Ағымдағы жылжыту күйіні жою',
	'ariaDeleteDrillStateLabel': 'Жоғарғы не төменгі санақты өңдеу үшін ENTER пернесін басыңыз.',
	'drillUpStateTitle': 'Жоғары жылжу',
	'drillDownStateTitle': 'Төмен жылжу',
	'ariaEditTopBottomLabel': 'Жоғарғы не төменгі санақты өңдеу үшін ENTER пернесін басыңыз.',
	'ariaDeleteTopBottomLabel': 'Жоғарғы не төменгі санақты жою үшін DELETE пернесін басыңыз.',

	// Authoring filtering
	'dimFilterIn': 'Құрамында: %{in}',
	'dimFilterNotIn': 'Қоспайды: %{out}',
	'measureFilterBetween': '%{lowerBound} және %{upperBound} арасында',
	'measureFilterNotBetween': '%{lowerBound} және %{upperBound} арасында емес',
	'gtFilter': 'Кейін %{lowerBound}',
	'ltFilter': 'Бұрын %{upperBound}',
	'notGtFilter': 'Кейін емес %{lowerBound}',
	'notLtFilter': 'Бұрын емес %{upperBound}',
	'localFilterTitle': 'Тек осы нысан',
	'globalFilterTitle': 'Барлығы нысандар',
	'deleteFilter': 'Сүзгіні жою',
	'editFilter': 'Сүзгіні өңдеу',
	'ariaEditFilterLabel': 'Сүзгіні өңдеу үшін ENTER пернесін басыңыз.',
	'ariaDeleteFilterLabel': 'Сүзгіні жою үшін DELETE пернесін басыңыз.',

	// Prompts
	'ariaEditPrompt': 'ENTER пернесін хабарлу мәнін өзгерту үшін басыңыз',

	'moreDataIndicator': 'Сіздің дерегіңіз %{threshold} элементтерінде қиылды. Сүзгіні аз көрсету үшін қабылдаңыз.',

	// data point filtering
	'dataPointFilterTitle': 'Деректер нүктелері',
	'dataPointFilterIncludeSummary': '%{valueCount} дерек нүктелері ендірілген',
	'dataPointFilterExcludeSummary': '%{valueCount} дерек нүктелері шеттетілген',

	// DB2 connection page
	'db2Database': 'DB2 Дерекқоры (%{jdbcConnection})',
	'db2Title': 'IBM DB2 дерекқорына қосылу',

	// Database
	'databaseConnectionMessage': 'Жеке дерекқор мәліметтерін көрсетіңіз:',
	'connectionString': 'Дерекқор қосылу жолы',
	'databaseCredentials': 'Тіркелгі деректер: ',
	'databaseUserName': 'Пайдаланушы аты',
	'databasePassword': 'Құпия сөз',
	'databaseConnect': 'Қосылу',

	// Twitter Keyword page
	'twitterTitle': 'Twitter',
	'twitterKeywordMessage': 'Іздеу терминін енгізіңіз:',
	'twitterKeyword': 'Кілт сөз',
	'twitterSearch': 'Іздеу',

	// NewConnectionView Providers
	'twitterProvider': 'Twitter',
	'dropboxProvider': 'Dropbox',
	'db2Provider': 'DB2',

	'workbookCreateFailed': 'Біз келесі көріністі жасай алмадық: %{error}\nFailed operation: %{lastOp}',

	// Expanded View, Focus View
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'widgetFiltersLabel': 'Виджет сүзгілері',
	'missingColumn': 'Жоқ: %{columnLabel}',
	'missingFiltering': 'Келесі баған идентификаторларының жоқ сүзгілері:',
	'heatByLabel': 'Қатынасу жиілігі арқылы',
	'evColumns': 'Бағандар',
	'evLocalFilters': 'Жергілікті сүзгілер',
	'evExpand': 'Кеңейту',
	'evFilterTooltip': 'Сүзгі',
	'evAdd': 'Баған қосу',

	// Navigation View
	'navigationBack': 'Артқа',

	// Pinning
	'contentPinFail': 'Келесі мазмұнды жинастыра алмадық. Әрекетті кейінірек қайталаңыз.',
	'contentPinFailOld': 'Келесі мазмұнды бекіте алмадық. Әрекетті кейінірек қайталаңыз.',

	// Layouts
	'dropZoneLabel': 'ұлғайту үшін мында апару',

	//Share
	'shareDefaultPageTitle': 'Бет %{index}',

	'nextPage': 'Келесі бет',
	'previousPage': 'Алдыңғы бет',

	'assetAssembly': 'көрініс',

	'toolbar_save': 'Сақтау',
	'brgr_saveAs': 'Басқаша сақтау',
	'brgr_refresh': 'Жаңарту',

	// Save
	'saving': 'Сақтауда...',
	'save_success': 'Жеке көрінісіңіз сақтаулы.',
	'save_failure': 'Біз кешірім өтінеміз. Жеке көрінісіңізді сақтау мүмкін болмады. Әрекетті кейінірек қайталаңыз.',
	'dashboard_save_success': 'Сіздің жиынтық тақтаңыз сақталды.',

	'geminiLeave': 'IBM Watson Analytics бағдарламасынан шығуды қаладыңыз.',

	'warning': 'Ескерту',
	'missingDataSetData': 'Бұл деректер жиыны үшін деректер қолжетімсіз келеді. Көзге қатынас үшін әкімшіңізге қатынас орнатыңыз немесе деректер жиыныңызды жаңартыңыз.',

	// Calculations
	'error_calculation_in_use': 'Таңдалған есептеу қолданыста және жойылуы мүмкін емес.',

	'resize': 'Өлшемді өзгерту',
	'rotate': 'Айналдыру',
	'moveHandle': 'Виджетті жылжу',
	'expandHandle': 'Кеңейту',
	'panHandle': 'Панорамалау',

	//Navigation
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'navigateTitle': 'Келесіге шарлау',

	// Slide out titles
	'shapeSlideoutTitle': 'Пішімдер',
	'textSlideoutTitle': 'Мәтін',
	'mediaSlideoutTitle': 'Мультимедиа',
	'visualizationSlideoutTitle': 'Көрнекі құралдар',

	// Board Model Dialog Messages
	'invalidJSONResponse': 'Қамтамасыз JSON жарамсыз. Қосымша ақпарат алу үшін, қателер журналын қараңыз.',

	// Widget type labels
	'shape_label': 'Кескін',
	'image_label': 'Кескін',
	'data_label': 'Диаграмма',
	'media_label': 'Мультимедиа',
	'text_label': 'Мәтін',
	'embedMedia_label': 'Мультимедиа',
	'youtube_label': 'YouTube бейнесі',
	'webpage_label': 'Веб-бет',

	// **** Smart names for objects ****
	// You might think that one_name is useless, but we have it in case we need to change that resource into one_name_numbered
	'one_name': '%{name}',
	'one_name_numbered': '%{name} (%{number})',
	'noExtraText_shape': 'Кескін',
	'noExtraText_shape_numbered': 'Пішін (%{number})',
	'few_shape': '%{count} пішін тобы',
	'many_shape': '%{count} пішін тобы',
	// %{text} is the description of the image, specified in the properties by the user
	'one_image': '%{text} кескін',
	'one_image_numbered': '%{text} кескін (%{number})',
	'noExtraText_image': 'Кескін',
	'noExtraText_image_numbered': 'Кескін (%{number})',
	'few_image': '%{count} кескіндер тобы',
	'many_image': '%{count} кескіндер тобы',
	'noExtraText_text': 'Бос мәтін терезесі',
	'noExtraText_text_numbered': 'Бос мәтін терезесі (%{number})',
	'few_text': '%{count} мәтін терезесінің тобы',
	'many_text': '%{count} мәтін терезесінің тобы',
	// Crosstab: values by Row1 (and Column1)
	'crosstab_opt_mapping': '%{row_level1} арқылы %{values} және %{column_level1} айқас кесте',
	'crosstab_opt_mapping_numbered': '%{row_level1} арқылы %{values} және %{column_level1} (%{number}) айқас кесте',
	'crosstab_has_mapping': '%{row_level1} арқылы %{values} айқас кесте',
	'crosstab_has_mapping_numbered': '%{values} by %{row_level1}арқылы %{values} (%{number}) айқас кесте',
	'crosstab_no_mapping': 'Бос кросс кесте',
	'crosstab_no_mapping_numbered': 'Бос кросс кесте (%{number})',
	'crosstab_named': '%{name} кросс кесте',
	'crosstab_named_numbered': '%{name} кросс кесте (%{number})',
	// Grid: first column grid
	'JQGrid_has_mapping': '%{grid_cols} кесте',
	'JQGrid_has_mapping_numbered': '%{grid_cols} кесте (%{number})',
	'JQGrid_no_mapping': 'Бос кесте',
	'JQGrid_no_mapping_numbered': 'Бос кесте (%{number})',
	'JQGrid_named': '%{name} кесте',
	'JQGrid_named_numbered': '%{name} кесте (%{number})',
	// Hierarchy: level one hierarchy
	'hierarchy_has_mapping': '%{level1} иерархия',
	'hierarchy_has_mapping_numbered': '%{level1} иерархия (%{number})',
	'hierarchy_no_mapping': 'Бос иерархия',
	'hierarchy_no_mapping_numbered': 'Бос иерархия (%{number})',
	'hierarchy_named': '%{name} иерархия',
	'hierarchy_named_numbered': '%{name} иерархия (%{number})',
	// Legacy map: Region heat by Regions map
	'map_has_mapping': '%{categories} карта',
	'map_has_mapping_numbered': '%{categories} карта (%{number})',
	'map_no_mapping': 'Бос карта',
	'map_no_mapping_numbered': 'Бос карта (%{number})',
	'map_named': '%{name} карта',
	'map_named_numbered': '%{name} карта (%{number})',
	// Summary value: value summary value
	'summary_has_mapping': '%{actual} жиынтық мән',
	'summary_has_mapping_numbered': '%{actual} жиынтық мән (%{number})',
	'summary_no_mapping': 'Бос жиынтық мән',
	'summary_no_mapping_numbered': 'Бос жиынтық мән (%{number})',
	'summary_named': '%{name} жиынтық мән',
	'summary_named_numbered': '%{name} жиынтық мән (%{number})',

	// KPI: actual value, optional time
	'kpi_opt_mapping': '%{sparkline.time} арқылы %{actual} ТНК',
	'kpi_opt_mapping_numbered': '%{sparkline.time} ТНК (%{number}) арқылы %{actual}',
	'kpi_has_mapping': '%{actual} ТНК',
	'kpi_has_mapping_numbered': '%{actual} ТНК (%{number})',
	'kpi_no_mapping': 'Бос ТНК',
	'kpi_no_mapping_numbered': 'Бос ТНК (%{number})',
	'kpi_named': '%{name} Бос ТНК',
	'kpi_named_numbered': '%{name} ТНК (%{number})',

	// (Infographic summary) Infographic: value infographic
	'infographicSummary_has_mapping': '%{actual} инфографика',
	'infographicSummary_has_mapping_numbered': '%{actual} инфографика (%{number})',
	'infographicSummary_no_mapping': 'Бос инфографика',
	'infographicSummary_no_mapping_numbered': 'Бос инфографика (%{number})',
	'infographicSummary_named': '%{name} инфографика',
	'infographicSummary_named_numbered': '%{name} инфографика (%{number})',
	'noExtraText_youtube': 'YouTube бейнесі',
	'noExtraText_youtube_numbered': 'YouTube бейнесі (%{number})',
	// %{text} is the user-provided title of the video
	'one_youtube': '%{text} YouTube бейнесі',
	'one_youtube_numbered': '%{text} YouTube бейнесі (%{number})',
	'few_youtube': '%{count} YouTube бейнесінің тобы',
	'many_youtube': '%{count} YouTube бейнесінің тобы',
	'noExtraText_embedMedia': 'Мультимедия сілтемесі',
	'noExtraText_embedMedia_numbered': 'Мультимедия сілтемесі (%{number})',
	// %{text} is the user-provided title of the media link
	'one_embedMedia': '%{text} медиа сілтемесі',
	'one_embedMedia_numbered': '%{text} медиа сілтемесі (%{number})',
	'few_embedMedia': '%{count} медиа сілтемелердің тобы',
	'many_embedMedia': '%{count} медиа сілтемелердің тобы',
	'noExtraText_media': 'Мультимедиа',
	'noExtraText_media_numbered': 'Мультимедиа (%{number})',
	// %{text} is the user-provided title of the media link
	'one_media': '%{text} медиа',
	'one_media_numbered': '%{text} медиа (%{number})',
	'few_media': '%{count} медианың тобы',
	'many_media': '%{count} медианың тобы',
	'noExtraText_webpage': 'Веб-бет',
	'noExtraText_webpage_numbered': 'Веб бет (%{number})',
	// %{text} is the user-provided title of the web page
	'one_webpage': '%{text} веб бет',
	'one_webpage_numbered': '%{text} веб бет (%{number})',
	'few_webpage': '%{count} веб беттің тобы',
	'many_webpage': '%{count} веб беттің тобы',
	'one_unknown': 'Нысан',
	'one_unknown_numbered': 'Нысан (%{number})',
	'few_unknown': '%{count} нысанның тобы',
	'many_unknown': '%{count} нысанның тобы',

	//a11y label for the left/right arrow for navigation path

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'next': 'Келесі',
	'previous': 'Алдыңғы',
	//a11y description

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'current_nav_group': 'Ағымдағы шарлау тобы - %{navigation_group_name}',

	//Page Context
	'filterBlank': '(бос)',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'errMsgFilterItemGenericTitle': 'Сүзгі мәндері жүктелмейді',
	'editTimelineHighlight': 'Бөлектеуді өңдеу',

	'filterDockChevronLeft': 'Деректер бойынша айналдыру',
	'filterDockChevronRight': 'Деректер бойынша айналдыру',
	'expand': 'Кеңейту',
	'collapse': 'Тасалау',

	//Reset Dashboard
	'dashboardResetTitle': 'Басқару тақтасын қалпына келтіру',
	'dashboardResetMessage': 'Бұл бақылау тақтасына қолданылған барлық өзгерістерді қалпына келтіруғе сенімдісіз бе?',
	'dashboardResetToast': 'Сіздің жиынтық тақтаңыз келтірілді.',

	//Generate PDF
	'buildingPDF': 'PDF құру...',
	'exportPDF': 'PDF пішіміне экспорттау',
	'pageSize': 'Бет өлшемі',
	'orientation': 'Бағдар',
	'filtersPresentPDF': 'Алдыңғы беттегі көрнекілендіру(лер)ге қолданылған сүзгі(лер):',
	'errorPDF': 'PDF жасау мүмкін болмады. Жаңартыңыз және қайталап көріңіз.',
	'printPDFInfo': 'Құжаттамаларды қарау',
	'pdfWidget': 'Виджет',
	'includeFilters': 'Сүзгі мәліметтерін көрсету',
	'portrait': 'Кітаптық',
	'landscape': 'Альбомдық',
	'letter': 'Әріп',
	'legal': 'Ресми',
	'a4':'A4',
	'tabloid':'Таблоид',

	'toastUpgradeDone': 'Сіздің жиынтық тақтаңыз жаңартылмады. Оңтайлы өнімділікті қолдау үшін қазір сақтаңыз.',

	'ariaFullScreenMessage': 'Толық экраннан режимінен шығу үшін Escape пернесін басыңыз',

	/**********************************************
	*******************LIVE WIDGET*****************
	***********************************************/
	// Hierarchy Packed Bubble
	'LIVE_hierarchy_packed_bubble_has_mapping': '%{categories} бумаланған иерархия көпіршікті кестесі',
	'LIVE_hierarchy_packed_bubble_has_mapping_numbered': '%{categories} бумаланған иерархия көпіршікті кестесі (%{number})',
	'LIVE_hierarchy_packed_bubble_no_mapping': 'Бос бумаланған иерархияның көпіршікті диаграммасы',
	'LIVE_hierarchy_packed_bubble_no_mapping_numbered': 'Бос бумаланған иерархияның көпіршікті диаграммасы (%{number})',
	'LIVE_hierarchy_packed_bubble_named': '%{name} бумаланған иерархияның көпіршікті диаграммасы',
	'LIVE_hierarchy_packed_bubble_named_numbered': '%{name} бумаланған иерархияның көпіршікті диаграммасы (%{number})',

	// Marimekko
	'LIVE_marimekko_has_mapping': 'by %{values} арқылы %{categories} marimekko диаграммасы',
	'LIVE_marimekko_has_mapping_numbered': '%{values} арқылы %{categories} marimekko диаграммасы (%{number})',
	'LIVE_marimekko_no_mapping': 'Бос marimekko диаграммасы',
	'LIVE_marimekko_no_mapping_numbered': 'Бос marimekko диаграммасы (%{number})',
	'LIVE_marimekko_named': '%{name} marimekko диаграммасы',
	'LIVE_marimekko_numbered': '%{name} marimekko диаграммасы (%{number})',

	// Sunburst
	'LIVE_sunburst_has_mapping': '%{values} секторлық дөңгелек диаграмма',
	'LIVE_sunburst_has_mapping_numbered': '%{values} секторлық дөңгелек диаграмма (%{number})',
	'LIVE_sunburst_no_mapping': 'Бос секторлық дөңгелек диаграмма',
	'LIVE_sunburst_no_mapping_numbered': 'Бос секторлық дөңгелек диаграмма (%{number})',
	'LIVE_sunburst_named': '%{name} секторлық дөңгелек диаграммасы',
	'LIVE_sunburst_named_numbered': '%{name} секторлық дөңгелек диаграммасы (%{number})',

	// Driver Analysis
	'LIVE_decision_analysis_has_mapping': '%{values} драйверін талдау кестесі',
	'LIVE_decision_analysis_has_mapping_numbered': '%{values} драйверін талдау кестесі (%{number})',
	'LIVE_decision_analysis_no_mapping': 'Бос драйверді талдау кестесі',
	'LIVE_decision_analysis_no_mapping_numbered': 'Бос драйверді талдау кестесі (%{number})',
	'LIVE_decision_analysis_named': '%{name} драйверін талдау кестесі',
	'LIVE_decision_analysis_named_numbered': '%{name} драйверін талдау кестесі (%{number})',

	// Line and Column
	'LIVE_line_column_opt_mapping': '%{columnValue} арқылы %{categories} және %{lineValue} жол мен баған диаграммасы',
	'LIVE_line_column_opt_mapping_numbered': '%{columnValue} арқылы %{categories} және %{lineValue} жол мен баған диаграммасы (%{number})',
	'LIVE_line_column_has_mapping': '%{columnValue} және %{lineValue} жол мен баған диаграммасы',
	'LIVE_line_column_has_mapping_numbered': '%{columnValue} арқылы %{categories} және %{lineValue} жол мен баған диаграммасы (%{number})',
	'LIVE_line_column_no_mapping': 'Бос жол және баған диаграммасы',
	'LIVE_line_column_no_mapping_numbered': 'Бос жол және баған диаграммасы (%{number})',
	'LIVE_line_column_named': '%{name} сызық және баған диаграма',
	'LIVE_line_column_named_numbered' : '%{name} Сызық және баған диаграма (%{number})',

	// Bubble chart
	'LIVE_bubble_chart_has_mapping': '%{y} арқылы %{x} және %{size} көпіршікті диаграммасы',
	'LIVE_bubble_chart_has_mapping_numbered': 'by %{y} арқылы %{x} және %{size} көпіршікті диаграммасы (%{number})',
	'LIVE_bubble_chart_no_mapping': 'Бос көпіршікті диаграмма',
	'LIVE_bubble_chart_no_mapping_numbered': 'Бос көпіршікті диаграмма (%{number})',
	'LIVE_bubble_chart_named': '%{name} көпіршікті диаграмма',
	'LIVE_bubble_chart_named_numbered': '%{name} көпіршікті диаграмма (%{number})',

	// Bullet chart
	'LIVE_bullet_has_mapping': '%{actual} таңбалауыш диаграммасы',
	'LIVE_bullet_has_mapping_numbered': '%{actual} таңбалауыш диаграммасы (%{number})',
	'LIVE_bullet_no_mapping': 'Бос таңбалауыш диаграммасы',
	'LIVE_bullet_no_mapping_numbered': 'Бос таңбалауыш диаграммасы (%{number})',
	'LIVE_bullet_named': '%{name} таңбалауыш диаграммасы',
	'LIVE_bullet_named_numbered': '%{name} таңбалауыш диаграммасы (%{number})',

	// Serviceability
	'generalInfo': 'Жалпы',
	'widgetId': 'Виджет идентификаторы',
	'widgetType': 'Виджет түрі',
	'serviceability': 'Қызмет ету мүмкіндігі',
	'showInfoForAll': 'Барлық көрнекілендірулер үшін ұзақтығын көрсетіңіз',
	'hideInfoForAll': 'Барлық көрнекілендірулер үшін ұзақтығын жасырыңыз',
	'copyButton': 'Көшіру',
	'closeButton': 'Жабу',
	'specification': 'Спецификация',
	'viewSpecification': 'Көрініс сипаттамасы'
});
